/**
 *    Fetches and parses json file
 *    @param    url of the json file
 *    @param    init RequestInit params
 *    @returns  parsed data
 */
export const fetchData = async (url: string, init?: RequestInit) => {
  const response = await fetch(url, init)
  const data = await response.json()
  return data
}
